import XLSX from "xlsx";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: { gridTemplateColumns: "114px auto", default: new Date().getFullYear(), xlWidthFull: true, unit: "" },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: { gridTemplateColumns: "114px auto", default: { fieldId: "", fieldName: "" } },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({
      conditions: [
        { key: "header.year", operator: "=", value: `${year}`, boolean: "OR" },
        { key: "body.subInfo.제개정일", operator: "=", value: `${year}`, boolean: "OR" },
      ],
    });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    return conditions;
  },
  getDefaultSort: () => {
    return [
      { target: "#body.subInfo.구분1", direction: "asc" },
      { target: "#body.stdInfo.구분2", direction: "asc" },
    ]
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_ name",
        style: { width: "200px" },
      },
      {
        name: "공장명",
        key: "body.subInfo.공장명",
        style: { width: "200px" },
      },
      {
        name: "구분1",
        key: "body.subInfo.구분1",
        style: { width: "372px" },
        child: [
          {
            name: "No.",
            key: "body.subInfo.구분1",
            style: { width: "70px" },
          },
          {
            name: "문서명",
            key: "body.subInfo.구분1",
          },
        ],
      },
      {
        name: "구분2",
        key: "body.subInfo.구분2",
        style: { width: "372px" },
        child: [
          {
            name: "No.",
            key: "body.subInfo.구분2",
            style: { width: "70px" },
          },
          {
            name: "문서명",
            key: "body.subInfo.구분2",
          },
        ],
      },
      {
        name: "Rev",
        key: "body.subInfo.Rev",
        style: { width: "80px" },
      },
      {
        name: "제개정일",
        key: "body.subInfo.제개정일",
        style: { width: "120px" },
      },
      {
        name: "첨부",
        key: "body.fileList",
        style: { width: "80px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    let _datas = [];
    const splitString = (str) => {
      // 문자열에서 숫자와 텍스트 부분을 분리
      return str.split(". ");
    };

    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1:
        return func.getContent(value).subInfo.공장명; // 공장명
      case 2:
        // 구분1
        _datas = splitString(func.getContent(value).subInfo.구분1);
        if (_datas.length === 1) _datas = ["-", _datas[0]];
        return {
          type: "child",
          datas: _datas.length < 1 ? ["-", "-"] : _datas,
        };
      case 3:
        // 구분2
        _datas = splitString(func.getContent(value).subInfo.구분2);
        if (_datas.length === 1) _datas = ["-", _datas[0]];
        return {
          type: "child",
          datas: _datas.length < 1 ? ["-", "-"] : _datas,
        };
      case 4:
        const rev = func.getContent(value).subInfo.Rev;
        if (!rev || rev === 0) return "비대상";
        else return rev; // Rev
      case 5:
        return func.getContent(value).subInfo.제개정일; // 제개정일
      case 6:
        // 결과보고서첨부
        const file = func.getContent(value).fileList[0];
        return {
          type: "docs",
          file: file ? { ...file, fileName: file.name } : {},
        };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  customExcelDownload: (data, fileName) => {
    // 새로운 워크북 생성
    const wb = XLSX.utils.book_new();

    // 데이터를 추가할 워크시트 생성
    const ws_data = [
      ["No.", "사업장명", "공장명", "구분1", "", "구분2", "", "Rev", "제개정일", "첨부"],
      ["", "", "", "No.", "문서명", "No.", "문서명", "", "", ""],
    ];

    data.map((_d) => {
      ws_data.push([
        _d.No,
        _d.사업장명,
        _d.공장명,
        _d.구분1.datas ? _d.구분1.datas[0] : '',
        _d.구분1.datas ? _d.구분1.datas[1] : '',
        _d.구분2.datas ? _d.구분2.datas[0] : '',
        _d.구분2.datas ? _d.구분2.datas[1] : '',
        _d.Rev,
        _d.제개정일,
        _d.첨부.file.path ? _d.첨부.file.name : ""
      ]);
    });

    // 워크시트 데이터 추가
    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    // 병합 설정
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // A1:A2 병합
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // B1:B2 병합
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // C1:C2 병합
      { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } }, // H1:H2 병합
      { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } }, // I1:I2 병합
      { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } }, // J1:J2 병합

      { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // D1:E1 병합
      { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } }, // F1:G1 병합
    ];

    // 워크북에 워크시트 추가
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // 엑셀 파일 다운로드
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  },
};

export default list;
